module.exports = __webpack_public_path__ + "static/img/card_btn_share.86a0b239.png";